import React from "react";
import { withNamespaces } from 'react-i18next';

const AcBolsas = ({t}) => {
  return (
    <>
      <div className="accordion" id="accordionExample2">
        {/* 1 */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="heading1">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapse1"
              aria-expanded="true"
              aria-controls="collapse2"
            >
              {t('moduleFaqs:S3.A.A1.T') }
            </button>
          </h2>
          <div
            id="collapse1"
            className="accordion-collapse collapse"
            aria-labelledby="heading1"
            data-bs-parent="#accordionExample2"
          >
            <div className="accordion-body">
              <div className="p_accordion">
                <ul>
                  <li>
                    <p className="p_next">
                      <span dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S3.A.A1.P1') }}></span>
                      <a className='link' target='_blank' rel='noreferrer' href={t('moduleFaqs:S3.A.A1.Link')} title={t('moduleFaqs:S3.A.A1.Title')}>{t('moduleFaqs:S3.A.A1.Link')}</a>
                      <span  dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S3.A.A1.P2') }}></span>
                    </p>
                  </li>
                  <li>
                    <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S3.A.A1.P3') }}>
                    </p>
                  </li>
                  <li>
                    <p className="p_next" dangerouslySetInnerHTML={{ __html: t('moduleFaqs:S3.A.A1.P4') }}>
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces() (AcBolsas);
